/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Treatments/Content/Trigger",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let treatmentsValueData = fromData.useDataValue({ viewPath,
context: 'treatments',
})
let tabSelectedLedgerTreatmentIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.treatment_id',
})
let aggregateData = fromHelpers.getTreatmentName(treatmentsValueData, tabSelectedLedgerTreatmentIdValueData)
let treatmentsValueData1 = fromData.useDataValue({ viewPath,
context: 'treatments',
})
let tabSelectedLedgerTreatmentIdValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.treatment_id',
})
let aggregateData1 = fromHelpers.getTreatmentStatus(treatmentsValueData1, tabSelectedLedgerTreatmentIdValueData1)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<button
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--g-1-HFmAS': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Trigger.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="treatments"
 data="tab.selected.ledger.treatment_id"
 aggregate="helpers.js getTreatmentName"
 text={aggregateData}
 weight="medium"
 size="medium"
 display="block"
 width="100%"
 overflowX="hidden"
 textOverflow="ellipsis"
 whiteSpace="nowrap"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="treatments"
 data="tab.selected.ledger.treatment_id"
 aggregate="helpers.js getTreatmentStatus"
 text={aggregateData1}
 weight="medium"
 color={dtColorsNeutral400}
 size="small"
/>
</div>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={14}
 height={14}
 fill2={dtColorsNeutral400}
/>
</button>
{children}
</React.Fragment>)
}